export class AssetCheckListReq {
    checkListid: number;
    checkListName: string[];
    assetId: number;
    assetCategoryId: string;
    isActive: boolean;
    createdUser: string | null;
    updatedUser: string | null;
    versionFlag: number;
    assetCategory?: string
    assetsName?: number;
    model?:string
subName?:string
itemId?:number
itemName?:string

    constructor(
        checkListid: number,
        checkListName: string[],
        assetId: number,
        assetCategoryId: string,
        isActive: boolean,
        createdUser: string | null,
        updatedUser: string | null,
        versionFlag: number,
        assetCategory?:string,
        assetsName?: number,
        model?:string,
        subName?:string,
        itemId?:number,
    itemName?:string
    ) {
        this.checkListid = checkListid;
        this.checkListName = checkListName;
        this.assetId = assetId;
        this.assetCategoryId = assetCategoryId;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
        this.assetCategory = assetCategory;
        this.assetsName = assetsName;
        this.model =model
        this.subName = subName
        this.itemId =itemId
        this.itemName =itemName
        
    }
}
